const _ = require('lib/underscore')
const isCustomTextSpotlight = require('./is_custom_text_spotlight')
const spotlights = require('data/spotlights/all')
const log = require('log').create('get merged spotlight') // eslint-disable-line

module.exports = function getSpotlightData(user_spotlight) {
    const spotlight = _.findWhere(spotlights, { id: user_spotlight.type })

    // if user's spotlight doesn't return a valid spotlight data object, return undefined
    if (! spotlight) return

    // construct a new data object, merging the spotlight data with the user's
    const data = _.extend({}, user_spotlight, spotlight)

    // construct the label for spotlights that allow custom text
    if (isCustomTextSpotlight(data)) {
        data.label = spotlight.label.replace(/…/, ` ${data.text}`)

        // don't show a glyph on buttons with custom text cuz they're too long
        // delete data.glyph
    } else {
        // remove the text property for non-custom-text spotlights
        delete data.text
    }

    return data
}
